// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.description-info-text{padding:16px 24px;max-height:300px;overflow-y:auto}`, "",{"version":3,"sources":["webpack://./src/components/DescriptionInfo/DescriptionInfo.scss"],"names":[],"mappings":"AAAA,uBACE,iBAAA,CACA,gBAAA,CACA,eAAA","sourcesContent":[".description-info-text {\n  padding: 16px 24px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
